module.exports = __webpack_public_path__ + "img/file-------------1x-png-1@1x.0d91241f.png";